import { render } from "./CreatePatientPage.vue?vue&type=template&id=c61180c2&ts=true"
import script from "./CreatePatientPage.vue?vue&type=script&lang=ts"
export * from "./CreatePatientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Patient/CreatePatientPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c61180c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c61180c2', __exports__)) {
    api.reload('c61180c2', __exports__)
  }
  
  module.hot.accept("./CreatePatientPage.vue?vue&type=template&id=c61180c2&ts=true", () => {
    api.rerender('c61180c2', render)
  })

}


export default __exports__